import React, { useState } from 'react';
import { Timer } from 'lucide-react';
import { SESSION_EXTENSIONS } from '@/lib/sessionExtensions';
import { money } from '@/lib/posReceipt';
import ExtensionBayPicker from './ExtensionBayPicker';

// The three session extensions, sold as service items alongside the experiences.
// An extension is time on a rig that is already running, so every tile asks which
// live bay it belongs to before the line can go into the order.
export default function SessionExtensionTiles({ onAdd }) {
  // The extension awaiting a bay (null = no picker open).
  const [pending, setPending] = useState(null);

  const handleSelect = (bay) => {
    onAdd(pending, bay);
    setPending(null);
  };

  return (
    <section className="mt-8">
      <div className="flex items-center gap-2">
        <Timer className="w-4 h-4 text-primary" />
        <h2 className="text-white font-black text-sm tracking-widest uppercase">
          Session Extensions &amp; Overtime
        </h2>
      </div>
      <p className="text-white/40 text-xs mt-1 mb-4">
        Extra track time added to an active session.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {SESSION_EXTENSIONS.map((ext) => (
          <button
            key={ext.key}
            onClick={() => setPending(ext)}
            className="flex items-center gap-3 text-left px-4 py-3 border border-white/10 bg-[#111115] hover:border-white/30 hover:ring-2 hover:ring-white/10 transition-all"
          >
            {/* Compact single row: duration badge, name, then the price */}
            <span className="text-[10px] font-black tracking-widest text-primary border border-primary/40 px-2 py-0.5 shrink-0">
              {ext.badge}
            </span>
            <span className="text-white font-black text-sm uppercase leading-tight flex-1 min-w-0">
              {ext.name}
            </span>
            <span className="flex items-center gap-2 shrink-0">
              <span className="hidden xl:inline-flex items-center gap-1 text-white/35 text-[10px] font-bold tracking-widest">
                <Timer className="w-3 h-3" /> {ext.minutes} MINS
              </span>
              <span className="text-primary font-black text-lg">{money(ext.price)}</span>
            </span>
          </button>
        ))}
      </div>

      <ExtensionBayPicker
        open={!!pending}
        title="Attach Extension to Active Bay"
        onSelect={handleSelect}
        onClose={() => setPending(null)}
      />
    </section>
  );
}